'use es6';

import UIIllustration from 'UIComponents/image/UIIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
const ResultHeaderIllustration = props => {
  return /*#__PURE__*/_jsx("div", {
    className: "result-header-illustration",
    children: /*#__PURE__*/_jsx(UIIllustration, Object.assign({}, props, {
      width: "150px"
    }))
  });
};
export default ResultHeaderIllustration;